// extracted by extract-css-chunks-webpack-plugin
module.exports = {"signInToSave":"signInToSave_eauH7","signInToSaveIcon":"signInToSaveIcon_JypHe","signInToSavePrompt":"signInToSavePrompt_QVHCk","signInButton":"signInButton_M03vH"};